import React, { useState } from "react";
import PaymentMethodAccordion from "./PaymentMethodAccordion";
import usePaymentMethods from "hooks/userProfile/usePaymentMethods";
import { useAuth } from "contexts/AuthContext";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function PaymentInfo({ userId }) {
  const { paymentMethods, loading } = usePaymentMethods(userId);
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div>
      <h6 className="mb-0 fw-semibold text-sm">Payment methods</h6>
      <p className="mb-3 text-xxs">
        Set up, manage, and organize your payment choices to ensure convenience,
        flexibility, and security across all your activities
      </p>

      {/* loading state */}
      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="success" />
          <span className="ms-3" style={{ fontSize: "13.33px" }}>
            Loading...
          </span>
        </div>
      )}

      {/* empty state */}
      {!loading && paymentMethods.length === 0 && (
        <div className="text-center py-4 px-3 border rounded bg-light">
          <FontAwesomeIcon icon="credit-card" className="text-muted mb-2" />
          <h6 className="fw-semibold text-muted mb-1">
            No payment methods found
          </h6>
          <p className="text-xxs text-muted mb-0">
            This user has not added any payment methods yet.
          </p>
        </div>
      )}

      {/*success state */}
      {!loading &&
        paymentMethods.length > 0 &&
        paymentMethods.map((method, index) => (
          <PaymentMethodAccordion
            key={method.id}
            method={method}
            index={index}
            activeKey={openIndex}
            onToggle={(clickedIndex) =>
              setOpenIndex(openIndex === clickedIndex ? null : clickedIndex)
            }
          />
        ))}
    </div>
  );
}
